import { IEvent } from "core-integration/src/store/events/types";
import { formatRawAsLocal } from "core-integration/src/utils/datetime";
import { Alert } from "plos/src/components/alerts";
import { vars } from "plos/src/styles/theme.css";
import { Trans } from "react-i18next";
import StatusIcon from "../../../../img/icons/status.svg?react";
import { chipWarningWrapper } from "./alerts.css";

interface TransfersAlertProps {
  transferCosts: number;
  nextEvent: IEvent;
  transferChipName: string;
  showTransferChipWarning: boolean;
}

const TransfersAlert = ({
  transferCosts,
  nextEvent,
  transferChipName,
  showTransferChipWarning,
}: TransfersAlertProps) => {
  if (transferCosts > 0) {
    return (
      <Alert variant="error" isLiveRegion>
        <span>
          <Trans
            ns="transfers"
            i18nKey="confirmTransfers.alert.costs"
            values={{
              nextEventName: nextEvent.name,
              deadlineTime: formatRawAsLocal(nextEvent.deadline_time),
              transferCosts,
            }}
            components={{ strong: <strong /> }}
          >
            These transfers will be active for {"{{nextEventName}}"} (
            {"{{deadlineTime}}"} ) and{" "}
            <strong>
              will deduct {"{{transferCosts}}"}pts from your score!
            </strong>
          </Trans>
        </span>
      </Alert>
    );
  }

  return (
    <Alert isLiveRegion>
      <>
        {showTransferChipWarning && (
          <>
            <span className={chipWarningWrapper}>
              <StatusIcon
                fill={vars.colors.white}
                color={vars.colors.primary}
                width={16}
              />
              <Trans
                ns="transfers"
                i18nKey="confirmTransfers.alert.transferChipActive"
                values={{ transferChipName: transferChipName }}
                components={{ strong: <strong /> }}
              >
                <strong>{"{{transferChipName}}"} Active</strong>
              </Trans>
            </span>

            <span>
              <Trans
                ns="transfers"
                i18nKey="confirmTransfers.alert.transferChipWarning"
                values={{ transferChipName: transferChipName }}
              >
                Confirming this transfer locks in your {"{{transferChipName}}"}
                .{" "}
              </Trans>
            </span>
          </>
        )}
        <span>
          <Trans
            ns="transfers"
            i18nKey="confirmTransfers.alert.transfersActive"
            values={{
              nextEventName: nextEvent.name,
              deadlineTime: formatRawAsLocal(nextEvent.deadline_time),
            }}
          >
            These transfers will be active for {"{{nextEventName}}"} (
            {"{{deadlineTime}}"}).
          </Trans>
        </span>
      </>
    </Alert>
  );
};

export default TransfersAlert;
